/**
 * Base Webpack file
 *
 * /!\ SHOULD BE COMPLETED WITH AN ENVIRONMENT SPECIFIC FILE IN WEBPACK FOLDER /!\
 *
 * @module constants
 * @desc Constants of the project.
 * @property {('dev'|'demo'|'prod')}  environment            - Environment of the application.<br>
 *                                                             <u>dev</u>: Environment for development, add tools and logs for developers.<br>
 *                                                             <u>demo</u>: Environment for demonstration, restriction on demonstrated functionalities.<br>
 *                                                             <u>prod</u>: Environment for production, restriction on stables functionalities.
 * @property {string}                  baseUrl                - Base URL of the server.
 * @property {string}                  gmsUrl                 - Base URL of the GMS API.
 *                                                             Use variable "{iVersion}" for automatic replacement of the version number.
 * @property {integer}                maxPageSize            - Maximum number of elements per page for tables pagination.
 * @property {integer}                maxPageSizePerRequest  - Maximum number of elements per page for web services calling.
 * @property {integer}                pollIntervalMillis    - Milliseconds frequency of asynchrone web service polling.
 * @property {integer}                pollTimeoutMillis      - Timeout of asynchrone web service polling.
 * @property {integer}                pollPendingProvMillis  - Milliseconds frequency of pending provisioning web service polling.
 *
 */
const constants = {}
// Support email
constants.supportEmail = 'support@kerlink.fr'

// base URL of the server
constants.baseUrl = window.location.protocol + '//192.168.4.23'
constants.gmsUrl = constants.baseUrl + '/gms'
constants.docsUrl = constants.baseUrl + '/static/docs'
constants.requestTimeout = 120000

// Disconnection warning timeout
constants.disconnectionWarningTimeout = 120000

// =========== REMOTE SHELL ===========
constants.remoteShellActivation = true
constants.remoteShellUrl = window.location.protocol + '//192.168.4.23'
constants.remoteShellReconnection = true
constants.remoteShellReconnectionDelay = 5000
constants.remoteShellReconnectionDelayMax = 5000
constants.remoteShellReconnectionAttempts = 5
constants.remoteShellTimeout = 15000
constants.remoteRedirectAfterDisconnection = 3000

// =========== ASYNCHRONOUS TASKS ===========
// max page size for IHM
constants.maxPageSize = 100
// max page size by request for filters in list
constants.maxPageSizePerFilterRequest = 200
// max page size by request, usually for looping through all data
constants.maxPageSizePerRequest = 1000
// milliseconds frequency of asynchrone web service polling
constants.pollIntervalMillis = 1000
// milliseconds timeout of asynchrone web service polling
constants.pollTimeoutMillis = 30000
// milliseconds frequency of pending provisionings polling
constants.pollPendingProvMillis = 30000
// milliseconds frequency of customer polling to keep alarms updated
constants.alarmsRefresh = 120000

// =========== GATEWAYS ===========
// How many events (alarms and notifications) to display in gateway page
constants.overviewNbEvents = 6

// Polling timer for overview
constants.gatewayOverviewRefresh = 15000
constants.healthRefresh = 5000

// Software update max file size MB
constants.gatewaySoftwareUpdateMaxFilesizeMB = 100

// =========== FLEETS ===========
// Green, orange (and so, red) limits for alarms in fleet overview screen
constants.fleetAlarmThresholds = {
  green: 30,
  orange: 70
}

// Distribution ranges for fleet overview screen
const distributionRangesForPercentages = [
  { 'start': 0, 'end': 20, 'color': 'green' },
  { 'start': 21, 'end': 40, 'color': 'green' },
  { 'start': 41, 'end': 60, 'color': 'orange' },
  { 'start': 61, 'end': 80, 'color': 'orange' },
  { 'start': 81, 'end': 100, 'color': 'red' }
]
constants.fleetCpuDistribution = distributionRangesForPercentages
constants.fleetRamDistribution = distributionRangesForPercentages
constants.fleetSystemDiskDistribution = distributionRangesForPercentages
constants.fleetUserDiskDistribution = distributionRangesForPercentages
constants.fleetRssiDistribution = [
  { 'start': -120, 'end': -101, 'color': 'red' },
  { 'start': -100, 'end': -91, 'color': 'orange' },
  { 'start': -90, 'end': -81, 'color': 'orange' },
  { 'start': -80, 'end': -71, 'color': 'green' },
  { 'start': -70, 'end': -50, 'color': 'green' }
]
constants.fleetTemperatureDistribution = [
  { 'start': null, 'end': 50, 'color': 'green' },
  { 'start': 51, 'end': 60, 'color': 'green' },
  { 'start': 61, 'end': 70, 'color': 'orange' },
  { 'start': 71, 'end': 80, 'color': 'orange' },
  { 'start': 81, 'end': null, 'color': 'red' }
]

// =========== END-DEVICES ===========
constants.endDeviceOverviewRefresh = 60000

// =========== MAPS ===========
// tile server configuration
constants.tilesServerUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
constants.tilesServerAttribution = '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors'

// =========== COLORS ===========
// Colors from Kerlink theme
// Check _variables.scss from bootstrap-kerlink project
constants.colors = {}
constants.colors['white'] = '#fff'
constants.colors['gray-100'] = '#f8f9fa'
constants.colors['gray-200'] = '#eee'
constants.colors['gray-300'] = '#dee2e6'
constants.colors['gray-400'] = '#ced4da'
constants.colors['gray-500'] = '#bbb'
constants.colors['gray-600'] = '#666'
constants.colors['gray-700'] = '#444'
constants.colors['gray-800'] = '#222'
constants.colors['gray-900'] = '#212121'
constants.colors['black'] = '#000'

constants.colors['blue'] = '#1B3563'
constants.colors['indigo'] = '#6610f2'
constants.colors['purple'] = '#6f42c1'
constants.colors['pink'] = '#e83e8c'
constants.colors['red'] = '#F44336'
constants.colors['orange'] = '#FF9800'
constants.colors['yellow'] = '#FAB619'
constants.colors['green'] = '#4CAF50'
constants.colors['teal'] = '#20c997'
constants.colors['cyan'] = '#2196F3'

constants.colors['primary'] = constants.colors['blue']
constants.colors['secondary'] = constants.colors['yellow']
constants.colors['success'] = constants.colors['green']
constants.colors['info'] = constants.colors['cyan']
constants.colors['warning'] = constants.colors['orange']
constants.colors['danger'] = constants.colors['red']
constants.colors['light'] = constants.colors['white']
constants.colors['dark'] = constants.colors['gray-800']

// Export module
export default constants
